uic-table-column-icon {
    display: none;
}

uic-table .uic-table-column-icon__icon {
    margin-right: 8px;
}
